import axios, { AxiosResponse } from 'axios';
// import { setupInterceptorsTo } from './Interceptors';
import { setupInterceptorsTo } from '@/shared/services/httpInterceptors';

import { LoginRequest, RefreshLoginRequest, LogoutRequest } from '@/modules/ewwms/models/Lager/LagerModels';

/* DEV */
import config from '@/../appsettings.dev.json';

/* PROD */
// const appsettings = await fetch('/appsettings.test.json')
// const appsettings = await fetch('/appsettings.json');
// const config = await appsettings.json();

const env = window.__ENV__ ?? null;

const BASE_URL = (env != undefined && env?.BASE_URL != undefined && env?.BASE_URL != '' ? env?.BASE_URL : config.api.baseUrl) + '/v1';
const TENANT = env != undefined && env?.AUTH_DEFAULT_REALM != undefined && env?.AUTH_DEFAULT_REALM != '' ? env?.AUTH_DEFAULT_REALM : config.auth.defaultRealm;

const apiClient = setupInterceptorsTo(
  axios.create({
    baseURL: BASE_URL,
    withCredentials: false,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      tenant: TENANT,
    },
  })
);

export default {
  //#region Auth
  login(data: LoginRequest): Promise<AxiosResponse> {
    return apiClient.post('/login', data);
  },

  refreshLogin(data: RefreshLoginRequest): Promise<AxiosResponse> {
    return apiClient.post('/login/refresh', data);
  },

  logout(data: LogoutRequest): Promise<AxiosResponse> {
    return apiClient.post('/logout', data);
  },
  //#endregion
};
